import { useQuery } from '@tanstack/react-query';

import { getCommissionerChannelDataByUserId } from '../../../services/commissioner/commissioner-service.service.api';

const STALE_TIME = 30_000;

export const commissionerChannelByUserIdKey = (userId: string, withStats: boolean) =>
  ['commissioner/channel', userId, withStats] as const;

export const useCommissionerChannelByUserId = ({
  userId,
  withStats = true,
}: {
  userId: string;
  withStats?: boolean;
}) =>
  useQuery({
    queryKey: commissionerChannelByUserIdKey(userId, withStats),
    queryFn: ({ signal }) => getCommissionerChannelDataByUserId(userId, signal, { withStats }),
    staleTime: STALE_TIME,
    enabled: !!userId,
  });
